import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Image from "../atoms/Image"
import CopyBlock from "../molecules/CopyBlock"
import Cells from "../organisms/Cells"

import Button from "../../images/button.svg"
import Gift from "../../images/gift.svg"
import Map from "../../images/map.svg"
import PartlyCloudy from "../../images/partly-cloudy.svg"
import Rings from "../../images/rings.svg"

const InstructionsView = props => (
  <StaticQuery
    query={graphql`
      query {
        image1: file(relativePath: { eq: "IMG_0143.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        image2: file(relativePath: { eq: "IMG_0391.jpg" }) {
          childImageSharp {
            fluid(
              maxWidth: 600
              maxHeight: 600
              quality: 100
              cropFocus: WEST
            ) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        image3: file(relativePath: { eq: "IMG_0610.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 600, maxHeight: 600, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        image4: file(relativePath: { eq: "IMG_0635-3.jpg" }) {
          childImageSharp {
            fluid(
              maxWidth: 600
              maxHeight: 600
              quality: 100
              cropFocus: EAST
            ) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const items = [
        <CopyBlock icon={<Rings />} title="Saturday Sept 21">
          <p>Ceremony begins @5pm, dinner and drinks to follow</p>
        </CopyBlock>,
        <Image fluid={data.image1.childImageSharp.fluid} alt="" />,
        <CopyBlock icon={<Map />} title="Cipresso Castle">
          <address>
            3000 Cathedral Pl
            <br />
            Decatur, GA 30034
            <br />
            <a href="https://docs.google.com/document/d/1UO7Z6KaFY-wjKCUkiHyFMiY5Ps_tPXZKNUCplPD7FHo/edit?usp=sharing">directions (updated)</a>
          </address>
        </CopyBlock>,
        <Image fluid={data.image2.childImageSharp.fluid} alt="" />,
        <CopyBlock icon={<PartlyCloudy />} title="Outdoors">
          <p>
            Weather permitting, the ceremony and reception will be held
            outdoors.
          </p>
        </CopyBlock>,
        <Image fluid={data.image3.childImageSharp.fluid} alt="" />,
        <CopyBlock icon={<Button />} title="Casual">
          <p>
            Please dress to be comfortable for a lovely low key evening.
            (Gentlemen, that means button-downs.)
          </p>
        </CopyBlock>,
        <Image fluid={data.image4.childImageSharp.fluid} alt="" />,
        <CopyBlock icon={<Gift />} title="No Gifts Necessary">
          <p>
            Your company and support is all we need. If you’d still like to send
            us a gift, we’d be honored if you contributed to our{" "}
            <a href="https://www.honeyfund.com/wedding/BinionBond">
              Honeymoon Fund.
            </a>
          </p>
        </CopyBlock>,
      ]
      return <Cells items={items} />
    }}
  />
)

export default InstructionsView
